import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 5161A499-05B1-444F-84E6-359F5C46F84C
 * name contain-start
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/contain-start.svg
 * tags
 */
export const ContainStartIcon = createSvgIcon(<><path d="M2,3H8V5H4V19H8V21H2V3M7,17V15H9V17H7M11,17V15H13V17H11M15,17V15H17V17H15Z" /></>, 'ContainStartIcon');
export default ContainStartIcon